// extracted by mini-css-extract-plugin
export var adjacentSlide = "_ny-9";
export var arrowButtonContainer = "_ny-5";
export var arrowButtonIcon = "_ny-6";
export var carouselArrowButton = "_ny-2";
export var carouselElementContainer = "_ny-1";
export var currentSlide = "_ny-8";
export var left = "_ny-3";
export var otherSlide = "_ny-a";
export var productCarouselContainer = "_ny-0";
export var right = "_ny-4";
export var sliderOverflow = "_ny-7";